  
    import CardRh from   "@/components/cards/ManzaCard.vue" 
    import { Options , Vue } from "vue-class-component";   
    import {  Prop  , Watch } from 'vue-property-decorator';   
    @Options({
        name: "HistoricoPdf",
        components: {  CardRh  },   
    }) 
    export default class HistoricoPdf extends Vue { 
        
        @Prop( ) readonly matricula!: any  
        @Prop( ) readonly service!: any  
        @Prop( ) readonly token!: any  
        
        public identificador = 1 ;   
        public url: any = "";
        public modal: any = "modal_matricula_certificado";

        @Watch('matricula')
		dadosAtualizado(newVal: string) { 
            this.identificador++; 
		} 
  
        public gerarBoletim(){
            this.url =   null;  
            setTimeout(() => {
                this.url = this.service.getApiUrlCertificado() + '/matricula/' + this.matricula + '/gerar/certificado' + '?token=' + this.token ;;
                this.identificador++;
            }, 2 ); 
        }
    } 
